import request from '@/utils/request'

/**
 * 获取菜单目录列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回菜单目录列表
 */
export function listMenuCatalog(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuCatalog.listMenuCatalog',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加菜单目录
 * @param {Object} data 菜单目录数据
 * @returns {Promise} 返回操作结果
 */
export function saveMenuCatalog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuCatalog.saveMenuCatalog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新菜单目录
 * @param {Object} data 菜单目录数据
 * @returns {Promise} 返回操作结果
 */
export function updateMenuCatalog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuCatalog.updateMenuCatalog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除菜单目录
 * @param {Object} data 菜单目录数据
 * @returns {Promise} 返回操作结果
 */
export function deleteMenuCatalog(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/menuCatalog.deleteMenuCatalog',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}